import classnames from 'classnames';

import './Spinner.css';

export interface SpinnerProps {
  /**
   * Size of the spinner
   * @default 'medium'
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Color variant of the spinner
   * @default 'primary'
   */
  variant?: 'primary' | 'light' | 'dark';
  /**
   * Optional className for additional styling
   */
  className?: string;
  /**
   * Accessible label for screen readers
   * @default 'Loading'
   */
  ariaLabel?: string;
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

function Spinner({
  size = 'medium',
  variant = 'primary',
  className,
  ariaLabel = 'Loading',
  'data-testid': dataTestId,
}: SpinnerProps) {
  const spinnerClasses = classnames(
    'access-spinner',
    `access-spinner--${size}`,
    `access-spinner--${variant}`,
    className,
  );

  return (
    <span
      aria-label={ariaLabel}
      className={spinnerClasses}
      data-testid={dataTestId ?? 'spinner'}
      role='status'
    />
  );
}

export default Spinner;
